import React from 'react';
import cn from 'classnames';

import S from 'constants/string.const';
import { withTranslation } from 'providers/GILT.provider';
import { withTheme } from 'providers/Theme.provider';

import TableClientList from 'mergeClients/components/ExactDuplicates/TableClientList';

import CN from './TableDuplicateClientResult.module.scss';

class TableDuplicateClientResult extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isItemContentVisible: false,
      disabled: false,
    };
  }

  showContent = (id) => {
    this.setState({
      isItemContentVisible: {
        ...this.state.isItemContentVisible,
        [id]: true,
      },
    });
  };

  hideContent = (id) => {
    this.setState({
      isItemContentVisible: {
        ...this.state.isItemContentVisible,
        [id]: false,
      },
    });
  };

  mergeClients = (item) => {
    const duplicateIds = item.duplicates.map((s) => s.id);
    this.props.mergeClient(this.props.salonId, [
      {
        master_client: item.id,
        duplicate_clients: duplicateIds,
      },
    ]);
  };

  mergeAll = () => {
    const { clientList } = this.props;
    const duplicateClients = [];
    for (let i = 0; i < clientList.length; i += 1) {
      const mainId = clientList[i].id;
      if (clientList[i].duplicate_count > 0) {
        const duplicateIds = [];
        for (let j = 0; j < clientList[i].duplicates.length; j += 1) {
          duplicateIds.push(clientList[i].duplicates[j].id);
        }
        duplicateClients.push({
          master_client: mainId,
          duplicate_clients: duplicateIds,
        });
      }
    }
    this.props.mergeClient(this.props.salonId, duplicateClients);
    if (this.state.disabled) {
      return;
    }
    this.setState({ disabled: true });
  };

  render() {
    const { clientList, isDarkMode, t } = this.props;

    const headerText =
      clientList.length > 0 ? (
        t('exactDuplicateClients.clientsDuplicatesCount', { count: clientList.length })
      ) : (
        <>
          <p>{t('exactDuplicateClients.noDuplicatesMsgPart1')}</p>
          <p>{t('exactDuplicateClients.noDuplicatesMsgPart2')}</p>
        </>
      );
    return (
      <div
        className={cn({
          [CN.component]: true,
          [CN.dark]: isDarkMode,
        })}
      >
        <div className={CN.container}>
          <h3 className={CN.title}>{headerText}</h3>
          {clientList?.length > 0 ? (
            <button className={`btn btn-violet btn-shadow ${this.state.disabled ? 'disabled' : 'nothing'}`} onClick={this.mergeAll} disabled={this.props.disableMergeAllButton}>
              {t('exactDuplicateClients.mergeAllButton')}
            </button>
          ) : (
            <div />
          )}
        </div>

        <table className="tbl-client-box">
          <tbody>
            {clientList?.map((item) => (
              <tr className="tbl-row" key={item.id}>
                <td className="">
                  {item.isMerged === false && (
                    <table className="tbl-inner-result">
                      <tbody>
                        <tr>
                          <td colSpan="5">
                            <div className="visible-content">
                              <table className="tbl-single-row">
                                <tbody>
                                  <tr>
                                    <td className="merge-width">
                                      <span className="d-block font-big">
                                        <button className="btn btn-violet btn-shadow" onClick={() => this.mergeClients(item)}>
                                          {t('exactDuplicateClients.mergeButton')}
                                        </button>
                                      </span>
                                    </td>
                                    <td className="toggle-width">
                                      {this.state.isItemContentVisible[item.id] ? (
                                        <div onClick={() => this.hideContent(item.id)} className="hide-table" role="button" tabIndex="0">
                                          <div className="client-name text-cap">
                                            {S.space}
                                            {item.user_name}
                                            <span className="d-inline">
                                              {S.space}
                                              {t('exactDuplicateClients.mergeButton', { count: item.duplicate_count })}
                                            </span>
                                          </div>
                                          <div className="btn-toggle-table">{t('common.buttons.close')}</div>
                                        </div>
                                      ) : (
                                        <div className="show-table" onClick={() => this.showContent(item.id)} role="button" tabIndex="0">
                                          <div className="client-name text-cap">
                                            {S.space}
                                            {item.user_name}
                                            <span className="d-inline">
                                              {S.space}
                                              {t('exactDuplicateClients.mergeButton', { count: item.duplicate_count })}
                                            </span>
                                          </div>
                                          <div className="btn-toggle-table">{t('exactDuplicateClients.view')}</div>
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>

                            {this.state.isItemContentVisible[item.id] && (
                              <div className="hidden-content">
                                <TableClientList clientList={item.duplicates} />
                              </div>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  )}
                  {item.isMerged && <span className="successful-message">{t('exactDuplicateClients.successMsg', { user: item.user_name })}</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

const TableDuplicateClientResultHoc = withTranslation()(withTheme()(TableDuplicateClientResult));

export default TableDuplicateClientResultHoc;
